// Optional consuming-app seam. Apps without it keep their existing credit UI.
export function accountUsage(store, config) {
  const key=config && config.ACCOUNT_USAGE_GETTER;
  if (!key) return null;
  return store && store.getters && store.getters[key] || {
    status:'loading',label:'Usage',value:'Loading…',description:'Checking your allowance…',warning:null};
}
export function refreshAccountUsage(store, config) {
  const action=config && config.ACCOUNT_USAGE_ACTION;
  return action && store ? store.dispatch(action,{force:true}) : Promise.resolve(null);
}
